export const SpIdConnectionType: Record<string, number> = {
  SecondarySpId: 0,
  GrantorSpId: 1,
  Free: 2
};
